import t from "react";
import l from "./index68.mjs";
const i = ({
  month: e,
  year: o,
  locale: n = window.I18n.locale
}) => {
  const a = new Date(2023, e, 1).toLocaleDateString(n, {
    month: "long"
  });
  return /* @__PURE__ */ t.createElement("div", { className: l.month_title_container }, /* @__PURE__ */ t.createElement("h5", { "data-testid": "month-title" }, a, " ", o));
};
export {
  i as MonthTitle
};
